<template>
    <div class="scrollable-container">
      <Navbar />
      <div class="p-5 gray-background">
        <div class="card p-5 shadow">
          <div class="col-md-12 text-center">
            <h3>Consulta</h3>
          </div>
          <div class="card p-4 mt-3">
            <div class="row">
              <form @submit.prevent="submitForm" class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <label class="form-label">Fecha inicial</label>
                  <input type="date" class="form-control" id="validationCustom01" v-model="fechaIni" required />
                  <div class="invalid-feedback">Por favor, proporciona fecha incial valida.</div>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Fecha final</label>
                  <input type="date" class="form-control" id="validationCustom01" v-model="fechaFin" required />
                  <div class="invalid-feedback">Por favor, proporciona fecha final valida.</div>
                </div>
                <div class="col-md-2">
                  <button
                    class="btn btn-primary mt-3 float-right col-11"
                    type="submit"
                    style="border-radius: 15px;"
                  >
                    <i class="fas fa-search mr-2"></i>Buscar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div v-if="table">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Estación</th>
                  <th scope="col">Estatus</th>
                  <th scope="col">Asegurado</th>
                  <th scope="col">Fecha de registro</th>
                  <th scope="col">Folio</th>
                  <th scope="col">Tipo de tramite</th>
                  <th scope="col">Factura</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(datos, i) in paginatedData" :key="i">
                  <td>{{ datos.Estacion }}</td>
                  <td>{{ datos.Estatus }}</td>
                  <td>{{ `${datos.NombreAsegurado} ${datos.APaternoAsegurado} ${datos.AMaternoAsegurado}` }}</td>
                  <td>{{ datos.fecRegistro }}</td>
                  <td>{{ datos.Folio }}</td>
                  <td>{{ datos.TipoTramite }}</td>
                  <td>{{ datos.Factura }}</td>
                </tr>
              </tbody>
            </table>
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Anterior</a>
                </li>
                <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                  <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Siguiente</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <MensajeModal
        :Icon="icono"
        :Title="title"
        :Text="text"
        :ClassButton="classButton"
        :actionButton="actionButton"
      />
      <loading :isLoading="isLoading"></loading>
    </div>
  </template>
  
  <script>
  import Navbar from './Pages/Navbar.vue';
  import MensajeModal from './Modals/mensajeModal.vue';
  import Loading from './tools/loading.vue';
  
  export default {
    components: {
      MensajeModal,
      Loading,
      Navbar,
    },
    data() {
      return {
        table: false,
        isLoading: false,
        icono: 0,
        title: '',
        text: '',
        classButton: '',
        fechaIni: '',
        fechaFin: '',
        datosConsulta: [],
        currentPage: 1,
        itemsPerPage: 6,
      };
    },
    computed: {
      totalPages() {
        return Math.ceil(this.datosConsulta.length / this.itemsPerPage);
      },
      paginatedData() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.datosConsulta.slice(start, end);
      },
    },
    methods: {
      actionButton() {
        this.$modal.hide('mensaje');
      },
      submitForm() {
        this.consultaProvee();
        this.table = true;
      },
      formatDate(date) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      async consultaProvee() {
        console.log(this.fechaIni);
        console.log(this.fechaFin);
        this.isLoading = true;
        const payload = {
          metodo: "SOLICITUDPROVEEDORES",
          data: {
            JsonFiltro: `{"Usuario":"${localStorage.getItem("userId")}", "FecRegistro":"${this.formatDate(this.fechaIni)}", "FecRegistroHasta":"${this.formatDate(this.fechaFin)}"}`,
          },
        };
        console.log(payload);
  
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            this.datosConsulta = res;
            this.currentPage = 1;
            if (res == '') {
              this.table = false;
              this.$modal.show('mensaje');
              this.icono = 2;
              this.title = '';
              this.text = 'No se encontraron registros para el usuario ' + localStorage.getItem("userId");
              this.classButton = 'btn btn-danger col-3';
            }
          } else {
            console.log('error');
          }
        } catch {
          console.log('error');
        }
        this.isLoading = false;
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.currentPage = page;
        }
      },
    },
    mounted() {
      // this.consultaProvee();
    },
  };
  </script>
  
  <style>
  .btn-primary {
    background-color: #1e536b !important;
    border-color: #1e536b !important;
  }
  .card {
    border-radius: 30px;
  }
  .shadow {
    box-shadow: 0px 0px 10px 0px rgba(82, 82, 82, 0.26); /* Ajusta los valores según desees */
  }
  .page-link {
    color: #1e536b;
  }
  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #1e536b;
    border-color: #1e536b;
  }
  </style>
  